import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations } from "@/lib/translations";

const LanguageContext = createContext(null);
const LS_KEY = "bl_lang";

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "en";
    const saved = localStorage.getItem(LS_KEY);
    return saved && translations[saved] ? saved : "en";
  });

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((next) => {
    if (!translations[next]) return;
    localStorage.setItem(LS_KEY, next);
    setLangState(next);
  }, []);

  const t = useCallback(
    (key, vars) => {
      const path = key.split(".");
      let node = translations[lang];
      for (const p of path) {
        if (node && typeof node === "object" && p in node) node = node[p];
        else {
          node = undefined;
          break;
        }
      }
      if (node === undefined) {
        // fallback to English
        let en = translations.en;
        for (const p of path) {
          if (en && typeof en === "object" && p in en) en = en[p];
          else {
            en = key;
            break;
          }
        }
        node = en;
      }
      if (typeof node === "string" && vars) {
        return Object.keys(vars).reduce(
          (s, k) => s.replace(new RegExp(`{${k}}`, "g"), String(vars[k])),
          node
        );
      }
      return node;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useTranslation = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useTranslation must be used inside LanguageProvider");
  return ctx;
};

export const LANGUAGES = [
  { code: "en", label: "English", native: "English" },
  { code: "hi", label: "Hindi", native: "हिन्दी" },
  { code: "mr", label: "Marathi", native: "मराठी" },
  { code: "ta", label: "Tamil", native: "தமிழ்" },
  { code: "te", label: "Telugu", native: "తెలుగు" },
  { code: "bn", label: "Bengali", native: "বাংলা" },
  { code: "kn", label: "Kannada", native: "ಕನ್ನಡ" },
  { code: "gu", label: "Gujarati", native: "ગુજરાતી" },
];
